import React, { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";

function AlumniLIst() {
	const [alumniList, setAlumniList] = useState([]);
	useEffect(() => {
		axios
			.get("/api/alumini/getAllClient", {
				responseType: 'text'
			})
			.then((res) => {
				let data = res.data;
				try {
					const firstBrace = data.indexOf("{");
					const lastBrace = data.lastIndexOf("}");
					if (firstBrace !== -1 && lastBrace !== -1) {
						data = JSON.parse(data.substring(firstBrace, lastBrace + 1));
					}
				} catch (e) {
					console.log("JSON Parse Error", e);
				}
				setAlumniList(data.Data || []);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	return (
		<>
			<Helmet>
				<title>Our Alumni</title>
			</Helmet>
			<div className="PageContainer">
				<div className="AlumniHeader HeaderImg ">
					<img src="/Images/Banner/alumni.jpg" alt="banner" />
				</div>

				<div className="AlumniTableContainer">
					<div className="AlumniHeading">
						<div>
							<h3>Our Alumni</h3>
							<span className="border-bottom"></span>
						</div>
					</div>

					<div className="AlumniTable">
						<table>
							<thead>
								<tr>
									<th>Profile</th>
									<th>Name</th>
									<th>Company</th>
									<th>Designation</th>
									<th>Course</th>
									<th>Passing Year</th>
									<th>LinkedIn</th>
								</tr>
							</thead>
							<tbody>
								{alumniList && alumniList.length > 0 ? (
									alumniList.map((item, index) => (
										<tr key={index}>
											<td>
												<img
													src={
														"https://vbumcaapi.vbumca.in/storage/app/public/" +
														item.photo_location
													}
													alt="profile"
												/>
											</td>
											<td>{item.name}</td>
											<td>{item.company}</td>
											<td>{item.designation}</td>
											<td>{item.course}</td>
											<td>{item.passing_year}</td>
											<td>
												<a href={item.linkedin} target="_blank" rel="noreferrer">
													<b>Link</b>
												</a>
											</td>
										</tr>
									))
								) : (
									<tr>
										<td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>No records found.</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</>
	);
}

export default AlumniLIst;
